var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-avatar',{attrs:{"color":"grey darken-1","size":_vm.size}},[(_vm.imageUrl)?_c('img',{attrs:{"src":_vm.imageUrl},on:{"error":_vm.imageUrlError}}):_c('span',{staticClass:"white--text",style:('font-size:' + _vm.fontSize + 'px;')},[_vm._v(" "+_vm._s(_vm.initials)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }